import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import styles from "./UserSettingModal.module.scss";
import menuStyles from "../MenuModal/MenuModal.module.scss";

import shippingIcon from "../../../../src/static/icons/shipping-icon.svg";
import closeIcon from "../../../../src/static/icons/Back_btn_black.svg";
import paymentIcon from "../../../../src/static/icons/payment-icon.svg";
import allUsersIcon from "../../../../src/static/icons/AllUsers.svg";
import downArrow from "../../../../src/static/icons/downarrow.svg";
import voucherIcon from "../../../../src/static/icons/vouchers.svg";

import routes from "../../../routes";

const UserSettingModal = ({ isOpen, onDropDownClick, onBackClick, setSettingsModal, onClose }) => {
  const history = useHistory();
  const { userInfo } = useSelector((state) => state.authReducer);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "initial";
    };
  }, [isOpen]);

  const shippingHandler = () => {
    history.push(`/shipping/${userInfo.uid}/`);
    onClose();
  };

  const vouchersHandler = () => {
    history.push("/vouchers");
    onClose();
  };

  const renderItem = ({ label, icon, onClick }) => (
    <div
      key={label}
      className={menuStyles.MenuModalItemContainer}
      onClick={onClick}
    >
      <div className={menuStyles.MenuModalItemImageContainer}>
        <img src={icon} className={menuStyles.MenuModalItemImage} alt={label} />
      </div>
      <span className={menuStyles.MenuModalItem}>{label}</span>
    </div>
  );

  return (
    <div
      className={menuStyles.ModalWrap}
      onClick={onClose}
    >
      <div
        className={menuStyles.MenuModal}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={menuStyles.MenuModalContent}>
          {/* Shown only on mobile */}
          <img
            src={downArrow}
            className={menuStyles.dropDownArrow}
            onClick={onDropDownClick}
            alt="Dropdown"
          />

          <div className={styles.TermsHeader}>
            <button
              className={styles.CloseButton}
              onClick={onBackClick}
              aria-label="Go Back"
            >
              <img src={closeIcon} alt="Back" />
            </button>
            <div className={menuStyles.MenuModalTitle}>Settings</div>
          </div>

          <div className={menuStyles.MenuModalGrid}>
            {renderItem({
              label: "Profile",
              icon: allUsersIcon,
              onClick: () => {
                onClose();
                history.push(`/profile/${userInfo.uid}/settings`);
              }
            })}

            {renderItem({
              label: "Payment",
              icon: paymentIcon,
              onClick: setSettingsModal
            })}

            {renderItem({
              label: "Shipping",
              icon: shippingIcon,
              onClick: shippingHandler
            })}

            {renderItem({
              label: "Vouchers",
              icon: voucherIcon,
              onClick: vouchersHandler
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(UserSettingModal);
